var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 124,
    viewBox: "0 0 110 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67818 42.3474L45.4546 55.558C51.6536 57.5214 51.6536 66.0589 45.4546 68.0223L3.67818 81.2329C0.884559 82.1124 -0.649178 85.0353 0.263762 87.7538L3.51385 97.4907C4.41767 100.209 7.42129 101.702 10.2149 100.813L51.9914 87.6028C58.1903 85.6394 63.3484 92.5512 59.5232 97.6862L33.705 132.272C31.9795 134.582 32.5091 137.824 34.8828 139.503L43.4005 145.527C45.7742 147.206 49.1064 146.691 50.8319 144.381L76.6501 109.795C80.4845 104.66 88.8288 107.299 88.8288 113.642L88.8288 156.383C88.8288 159.244 91.2116 161.562 94.1513 161.562L104.678 161.562C107.617 161.562 110 159.244 110 156.383L110 -32.8206C110 -35.6812 107.617 -38 104.678 -38L94.1513 -38C91.2116 -38 88.8288 -35.6812 88.8288 -32.8206L88.8288 9.92061C88.8288 16.2638 80.4845 18.9024 76.6501 13.7674L50.8319 -20.8182C49.1065 -23.1281 45.7833 -23.6433 43.4005 -21.9643L34.8828 -15.9409C32.5091 -14.2618 31.9796 -11.0191 33.705 -8.70927L59.5232 25.8764C63.3576 31.0113 58.1994 37.9231 51.9914 35.9598L10.2149 22.7492C7.4213 21.8697 4.41768 23.3533 3.51386 26.0718L0.263767 35.8176C-0.640049 38.5361 0.884563 41.459 3.67818 42.3385L3.67818 42.3474Z",
    fill: "#FFF7F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.2c8a2ac427550503f5c863940671c22a.svg";
export { ForwardRef as ReactComponent };